import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // "Escucha" los cambios en la URL (pathname)
    // y ejecuta el scroll al inicio de la página.
    window.scrollTo(0, 0);
  }, [pathname]);

  // Este componente no renderiza nada visualmente.
  return null;
}

export default ScrollToTop;